export const CANDIDATE_STATUS_VALUES = [
  "New",
  "Contacted",
  "Active",
  "Hired",
  "Not Available",
  "Do Not Contact",
];

export const CANDIDATE_STATUS_OPTIONS = CANDIDATE_STATUS_VALUES.map((status) => ({
  value: status,
  label: status,
}));

// Slider labels and order follow the same source as Change Status.
export const CANDIDATE_STATUS_STATS = CANDIDATE_STATUS_VALUES.map(label => ({
  id: label.toLowerCase().replace(/\s+/g, "_"),
  label,
}));
